import React from 'react';
import cn from 'classnames';
import Attachment from '../NewAttachment/NewAttachment';
import styles from './AttachmentsList.module.scss';

const AttachmentsList = ({
  shownAttachments,
  allAttachments,
  getAttachmentUrl,
  onDeleteAttachment,
  rootClassName,
  attachmentClassName,
  showMetaData
}) => {
  return (
    <ul className={cn(styles.root, rootClassName)}>
      {shownAttachments.map((attachment) => {
        return (
          <li key={attachment.id}>
            <Attachment
              attachments={allAttachments}
              attachment={attachment}
              getAttachmentUrl={getAttachmentUrl}
              darkBackground
              showMetaData={showMetaData}
              onDeleteAttachment={onDeleteAttachment}
              className={attachmentClassName}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default AttachmentsList;
